(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ref-cart"] && !Shopify.designMode) return;
  try {
    
/* Compte a rebours du bandeau de rarete. Repart du debut a chaque chargement,
   comme sur la source. */
(function () {
  function wire(root) {
    root.querySelectorAll('[data-ref-cart-timer]').forEach(function (el) {
      if (el.dataset.refWired) return;
      el.dataset.refWired = '1';
      var left = (parseInt(el.getAttribute('data-ref-cart-timer'), 10) || 5) * 60;
      function tick() {
        var m = Math.floor(left / 60), s = left % 60;
        el.textContent = (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
        if (left > 0) { left--; setTimeout(tick, 1000); }
      }
      tick();
    });
  }
  document.addEventListener('DOMContentLoaded', function () { wire(document); });
  document.addEventListener('shopify:section:load', function (e) { wire(e.target); });
  wire(document);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ref-product-main"] && !Shopify.designMode) return;
  try {
    
/* Bundle : un produit par palier, ajout multi-lignes via /cart/add.js.
   Reinitialise sur shopify:section:load, sinon la section est morte apres une
   edition dans le Theme Editor. */
(function () {
  function wire(root) {
    root.querySelectorAll('[data-ref-atc]').forEach(function (btn) {
      if (btn.dataset.refWired) return;
      btn.dataset.refWired = '1';
      var sectionId = btn.getAttribute('data-ref-atc');
      btn.addEventListener('click', function () {
        var picked = document.querySelector('input[name="ref-tier-' + sectionId + '"]:checked');
        var items = [];
        if (picked) {
          var vid = picked.getAttribute('data-variant');
          var qty = parseInt(picked.getAttribute('data-quantity') || '1', 10) || 1;
          var gift = picked.getAttribute('data-gift');
          var offer = picked.getAttribute('data-offer') || '';
          // l'etiquette d'offre suit la ligne jusqu'au panier, comme sur la source
          var units = picked.getAttribute('data-units') || '';
          // le nombre d'unites physiques du palier : c'est lui qui permet au
          // panier d'afficher un prix unitaire juste (total / unites).
          var props = offer ? { '_Offre': offer } : {};
          if (units) props._Unites = units;
          if (!Object.keys(props).length) props = undefined;
          // Shopify empile les nouvelles lignes a l'envers de l'ordre d'envoi :
          // on envoie le cadeau d'abord pour que le produit principal soit en tete
          // du panier, comme sur la source.
          if (gift) items.push({ id: Number(gift), quantity: 1, properties: props });
          if (vid) items.push({ id: Number(vid), quantity: qty, properties: props });
        }
        if (!items.length) {
          var fb = btn.getAttribute('data-fallback-variant');
          if (fb) items.push({ id: Number(fb), quantity: 1 });
        }
        if (!items.length) return;
        btn.setAttribute('aria-busy', 'true');
        /* Les routes viennent du Liquid par attribut : dans un sous-dossier de marche
           (/it-it/...), '/cart/add.js' ecrirait dans le panier de la LANGUE PAR DEFAUT
           et renverrait l'acheteur sur le panier francais. */
        var addUrl = btn.getAttribute('data-cart-add-url') || '/cart/add.js';
        var cartUrl = btn.getAttribute('data-cart-url') || '/cart';
        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) { return r.json(); })
          .then(function () { window.location.href = cartUrl; })
          .catch(function () { btn.removeAttribute('aria-busy'); });
      });
    });
  }
  function wireThumbs(root) {
    root.querySelectorAll('[data-ref-thumbs]').forEach(function (btn) {
      if (btn.dataset.refWired) return;
      btn.dataset.refWired = '1';
      btn.addEventListener('click', function () {
        var wrap = btn.closest('.refsec-pdp__thumbs-wrap');
        var list = wrap && wrap.querySelector('.refsec-pdp__thumbs');
        if (!list) return;
        var step = Math.max(80, Math.round(list.clientWidth * 0.6));
        list.scrollBy({ left: btn.getAttribute('data-ref-thumbs') === 'next' ? step : -step, behavior: 'smooth' });
      });
    });
  }
  function wireSticky(root) {
    root.querySelectorAll('[data-ref-sticky]').forEach(function (bar) {
      if (bar.dataset.refWired) return;
      bar.dataset.refWired = '1';
      var id = bar.getAttribute('data-ref-sticky');
      var main = document.querySelector('#shopify-section-' + id + ' .refsec-pdp__atc');
      if (!main || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          // visible seulement quand le bouton principal est sorti PAR LE HAUT
          var gone = !en.isIntersecting && en.boundingClientRect.top < 0;
          bar.classList.toggle('is-shown', gone);
          bar.setAttribute('aria-hidden', gone ? 'false' : 'true');
        });
      }, { threshold: 0 });
      io.observe(main);
    });
  }
  function wireZoom(root) {
    root.querySelectorAll('[data-ref-zoom]').forEach(function (btn) {
      if (btn.dataset.refWired) return;
      btn.dataset.refWired = '1';
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-ref-zoom');
        var dlg = document.getElementById('ref-lightbox-' + id);
        if (!dlg || !dlg.showModal) return;
        var idx = btn.getAttribute('data-index');
        dlg.querySelectorAll('[data-zoom-slot]').forEach(function (s) {
          s.hidden = s.getAttribute('data-zoom-slot') !== idx;
        });
        dlg.showModal();
      });
    });
    root.querySelectorAll('[data-ref-zoom-close]').forEach(function (btn) {
      if (btn.dataset.refWired) return;
      btn.dataset.refWired = '1';
      btn.addEventListener('click', function () { btn.closest('dialog').close(); });
    });
  }
  document.addEventListener('DOMContentLoaded', function () { wire(document); wireThumbs(document); wireZoom(document); wireSticky(document); });
  document.addEventListener('shopify:section:load', function (e) { wire(e.target); wireThumbs(e.target); wireZoom(e.target); wireSticky(e.target); });
  wire(document); wireThumbs(document); wireZoom(document); wireSticky(document);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ref-reviews"] && !Shopify.designMode) return;
  try {
    
/* Tri client des avis. Reinitialise sur shopify:section:load, sinon le controle
   est mort apres une edition dans le Theme Editor. */
(function () {
  function wire(root) {
    root.querySelectorAll('[data-ref-rv-sort]').forEach(function (sel) {
      if (sel.dataset.refWired) return;
      sel.dataset.refWired = '1';
      var inner = sel.closest('.refsec-rv__inner');
      if (!inner) return;
      var items = [].slice.call(inner.querySelectorAll('.refsec-rv__item'));
      var original = items.slice();
      sel.addEventListener('change', function () {
        var mode = Number(sel.value);
        var sorted = original.slice();
        var stars = function (el) {
          var s = el.querySelector('.refsec-rv__stars');
          return s ? Number((s.getAttribute('aria-label') || '0').split('/')[0]) : 0;
        };
        if (mode === 1) sorted.sort(function (a, b) { return stars(b) - stars(a); });
        else if (mode === 2) sorted.sort(function (a, b) { return stars(a) - stars(b); });
        else if (mode === 6) sorted.sort(function (a, b) { return b.textContent.length - a.textContent.length; });
        var anchor = original[0];
        sorted.forEach(function (el) { anchor.parentNode.insertBefore(el, anchor); });
        sorted.forEach(function (el) { el.parentNode.appendChild(el); });
        var tail = inner.querySelectorAll('.refsec-rv__pager, .refsec-rv__group-title');
        [].slice.call(tail).forEach(function (el) { el.parentNode.appendChild(el); });
      });
    });
  }
  document.addEventListener('DOMContentLoaded', function () { wire(document); });
  document.addEventListener('shopify:section:load', function (e) { wire(e.target); });
  wire(document);
})();

  } catch(e) { console.error(e); }
})();
})();
